import { inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DateTimeService } from '@app-services/date-time.service';

/**
 * HTTP Interceptor that automatically converts date fields between UTC and local timezone.
 *
 * - Outgoing requests: Converts all fields ending with "Utc" from local → UTC
 * - Incoming responses: Converts all fields ending with "Utc" from UTC → local
 *
 * Handles nested objects and arrays recursively.
 */
export const DateInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
): ReturnType<HttpHandlerFn> => {
  const dateTimeService = inject(DateTimeService);

  if (
    request.body instanceof FormData ||
    request.body instanceof Blob ||
    request.body instanceof ArrayBuffer
  ) {
    return next(request);
  }

  let convertedBody = request.body;
  if (convertedBody && typeof convertedBody === 'object') {
    convertedBody = dateTimeService.toUtcObject(convertedBody);
  }

  const clonedRequest = request.clone({
    body: convertedBody,
  });

  return next(clonedRequest).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && event.body) {
        const convertedBody = dateTimeService.toLocalObject(event.body);
        return event.clone({
          body: convertedBody,
        });
      }

      return event;
    }),
  );
};
